export const POLL_REQUESTS_START = 'POLL_REQUESTS_START';
export type POLL_REQUESTS_START = typeof POLL_REQUESTS_START;

export const POLL_REQUESTS = 'POLL_REQUESTS';
export type POLL_REQUESTS = typeof POLL_REQUESTS;

export const POLL_REQUESTS_SUCCESS = 'POLL_REQUESTS_SUCCESS';
export type POLL_REQUESTS_SUCCESS = typeof POLL_REQUESTS_SUCCESS;

export const POLL_REQUESTS_FAILED = 'POLL_REQUESTS_FAILED';
export type POLL_REQUESTS_FAILED = typeof POLL_REQUESTS_FAILED;

export const POLL_REQUESTS_STOP = 'POLL_REQUESTS_STOP';
export type POLL_REQUESTS_STOP = typeof POLL_REQUESTS_STOP;

export const POLL_REQUEST_DETAILS_START = 'POLL_REQUEST_DETAILS_START';
export type POLL_REQUEST_DETAILS_START = typeof POLL_REQUEST_DETAILS_START;

export const POLL_REQUEST_DETAILS = 'POLL_REQUEST_DETAILS';
export type POLL_REQUEST_DETAILS = typeof POLL_REQUEST_DETAILS;

export const POLL_REQUEST_DETAILS_SUCCESS = 'POLL_REQUEST_DETAILS_SUCCESS';
export type POLL_REQUEST_DETAILS_SUCCESS = typeof POLL_REQUEST_DETAILS_SUCCESS;

export const POLL_REQUEST_DETAILS_FAILED = 'POLL_REQUEST_DETAILS_FAILED';
export type POLL_REQUEST_DETAILS_FAILED = typeof POLL_REQUEST_DETAILS_FAILED;

export const POLL_REQUEST_DETAILS_STOP = 'POLL_REQUEST_DETAILS_STOP';
export type POLL_REQUEST_DETAILS_STOP = typeof POLL_REQUEST_DETAILS_STOP;

export const CLEAR_REQUEST_DETAILS = 'CLEAR_REQUEST_DETAILS';
export type CLEAR_REQUEST_DETAILS = typeof CLEAR_REQUEST_DETAILS;

export const MANAGE_PAGE_CHANGE = 'MANAGE_PAGE_CHANGE';
export type MANAGE_PAGE_CHANGE = typeof MANAGE_PAGE_CHANGE;

export const MANAGE_PAGE_SIZE_CHANGE = 'MANAGE_PAGE_SIZE_CHANGE';
export type MANAGE_PAGE_SIZE_CHANGE = typeof MANAGE_PAGE_SIZE_CHANGE;

export const MANAGE_FILTERS_CHANGE = 'MANAGE_FILTERS_CHANGE';
export type MANAGE_FILTERS_CHANGE = typeof MANAGE_FILTERS_CHANGE;

export const MANAGE_SORT_CHANGE = 'MANAGE_SORT_CHANGE';
export type MANAGE_SORT_CHANGE = typeof MANAGE_SORT_CHANGE;

export const SUBMIT_RETRY_REQUEST = 'SUBMIT_RETRY_REQUEST';
export type SUBMIT_RETRY_REQUEST = typeof SUBMIT_RETRY_REQUEST;

export const SUBMIT_RETRY_REQUEST_FAILED = 'SUBMIT_RETRY_REQUEST_FAILED';
export type SUBMIT_RETRY_REQUEST_FAILED = typeof SUBMIT_RETRY_REQUEST_FAILED;

export const CLEAR_RETRY_REQUEST_FAILED_STATUS =
  'CLEAR_RETRY_REQUEST_FAILED_STATUS';
export type CLEAR_RETRY_REQUEST_FAILED_STATUS = typeof CLEAR_RETRY_REQUEST_FAILED_STATUS;

export const SUBMIT_RETRY_REQUEST_SUCCESS = 'SUBMIT_RETRY_REQUEST_SUCCESS';
export type SUBMIT_RETRY_REQUEST_SUCCESS = typeof SUBMIT_RETRY_REQUEST_SUCCESS;

export const DELETE_REQUEST = 'DELETE_REQUEST';
export type DELETE_REQUEST = typeof DELETE_REQUEST;
